import React, { useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';

const AddDeveloperCategoryModal = ({ isOpen, setIsOpen, fetchData }) => {
  const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
  const [imagePreview, setImagePreview] = useState(null);
  const [imageError, setImageError] = useState("");

  let [allcategory, SetCategory] = useState({
    category: "",
    status: "",
    position: "",
    user_id: isLoggedIn.user_id
  });

  const [image, setImage] = useState();

  const handleChange = (e) => {
    const { name, value } = e.target;
    SetCategory(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleStatusChange = (selectedOption) => {
    SetCategory(prevData => ({
      ...prevData,
      status: selectedOption ? selectedOption.value : ""
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedExtensions = ['jpeg', 'jpg', 'png', 'webp', 'avif'];
      const extension = file.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        setImageError("Only jpeg, jpg, png, webp, avif formats are allowed.");
        setImage(null);
        setImagePreview(null);
        return;
      }

      if (file.size > 1024 * 1024) {
        setImageError("Image size must be less than 1MB");
        setImage(null);
        setImagePreview(null);
        return;
      }

      setImageError("");
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!image || imageError) {
      toast.error("Please upload a valid image under 1MB", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('category', allcategory.category);
    formDataToSend.append('position', allcategory.position);
    formDataToSend.append('status', allcategory.status);
    formDataToSend.append('user_id', isLoggedIn.user_id);
    formDataToSend.append('image_logo', image);

    try {
      const response = await fetch(`https://100real.xyz/categoryfeaturedev/addcategory`, {
        method: "POST",
        body: formDataToSend
      });
      const res = await response.json();

      if (response.status === 200) {
        toast.success("Category added successfully!", {
          position: "top-center",
          autoClose: 2000,
        });
        SetCategory({
          category: "",
          status: "",
          position: "",
          user_id: isLoggedIn.user_id
        });
        setImage(null);
        setImagePreview(null);
        fetchData();
        setIsOpen(false);
      } else if (response.status === 400) {
        console.log(response)
        toast.error(res.message, {
          position: "top-center",
          autoClose: 2000,
        });
      }
    } catch (error) {
      toast.error(error.toString(), {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  const statusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
  ];

  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="oms-modal-title">Add Developer</h2>
        <form className="oms-modal-form" onSubmit={handleSubmit}>
          <div className="oms-form-group">
            <label htmlFor="image" className="oms-form-label">Image</label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={handleImageChange}
              required
            />
            {imageError && <p style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{imageError}</p>}
            {imagePreview && (
              <div style={{ marginTop: '10px' }}>
                <img
                  src={imagePreview}
                  alt="Preview"
                  style={{ width: '100%', maxHeight: '150px', objectFit: 'contain' }}
                />
              </div>
            )}
          </div>

          <div className="oms-form-group">
            <label htmlFor="category" className="oms-form-label">Category</label>
            <input
              type="text"
              name="category"
              id="category"
              value={allcategory.category}
              placeholder="Enter Category"
              onChange={handleChange}
              required
            />
          </div>

          <div className="oms-form-group">
            <label htmlFor="status" className="oms-form-label">Status</label>
            <Select
              options={statusOptions}
              placeholder="Select status"
              value={statusOptions.find(option => option.value === allcategory.status)}
              onChange={handleStatusChange}
              required
            />
          </div>

          <div className="oms-form-group">
            <label htmlFor="position" className="oms-form-label">Position</label>
            <input
              type="text"
              id="position"
              name="position"
              placeholder="Enter Position"
              value={allcategory.position}
              onChange={handleChange}
              required
            />
          </div>

          <div className="oms-form-actions">
            <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDeveloperCategoryModal;
